import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Divider from 'shared/components/Divider';
import { Button, Submit } from 'shared/components/Form';
import styles from './ButtonsRow.module.scss';

const ButtonsRow = ({
  processing,
  disabled,
  submitDisabled,
  submitClassName,
  cancelDisabled,
  onSubmit,
  onCancel,
  submitTitle,
  cancelTitle,
  noMargin,
  className,
  size,
  withDivider
}) => {
  const { t } = useTranslation('common');

  return (
    <div className={cn('row')}>
      <div
        className={cn('col-12', styles.wrapper, {
          [styles.noMargin]: noMargin,
          [styles.withDivider]: withDivider,
          [styles.small]: size === 'small'
        }, className)}
      >
        {withDivider && (<Divider spacing="large" />)}
        {onSubmit && (
          <Submit
            className={cn(styles.submit, submitClassName)}
            disabled={submitDisabled || disabled}
            processing={processing}
            onClick={onSubmit}
            title={submitTitle || t('button.save')}
          />
        )}
        {onCancel && (
          <Button
            disabled={cancelDisabled || disabled || processing}
            onClick={onCancel}
            title={cancelTitle || t('button.cancel')}
          />
        )}
      </div>
    </div>
  );
};

ButtonsRow.propTypes = {
  disabled: PropTypes.bool,
  submitDisabled: PropTypes.bool,
  submitClassName: PropTypes.string,
  cancelDisabled: PropTypes.bool,
  processing: PropTypes.bool,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  submitTitle: PropTypes.string,
  cancelTitle: PropTypes.string,
  className: PropTypes.string,
  noMargin: PropTypes.bool,
  size: PropTypes.oneOf(['normal', 'small']),
  withDivider: PropTypes.bool
};

ButtonsRow.defaultProps = {
  disabled: false,
  submitDisabled: false,
  submitClassName: null,
  cancelDisabled: false,
  processing: false,
  onSubmit: null,
  onCancel: null,
  submitTitle: null,
  cancelTitle: null,
  className: null,
  noMargin: false,
  size: 'normal',
  withDivider: false
};

export default ButtonsRow;
